import React, { useRef, useEffect, useContext, useState } from "react";
import { UserContext } from "App";
import {
  aggsFilterCategory,
  filterCategory,
  FilterProduct,
  particularCategoryData,
} from "../../../../../../../config/Services";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
import { useMemo } from "react";
import { useSnackbar } from "../../../../hooks/SnackbarProvider";
import "./index.css";
import { PosCustomButton } from "../../../../../../../customComponents/PosCustomButton/PosCustomButton";

const TabmodalSecond = () => {
  const firstRefElement = useRef(null);
  const showSnackbar = useSnackbar();
  const [categoryLoader, setCategoryLoader] = useState(true);
  const { setCategoryName } = useContext(UserContext);
  const [data, setData] = useState([]);
  const { setparticularCategoryItems } = useContext(UserContext);
  const navigate = useNavigate();
  const locId = localStorage.getItem("locId");
  const orgId = localStorage.getItem("orgId");
  const retailType = localStorage.getItem("retailType");

  const payload = {
    page: 1,
    pageSize: 50,
    sourceId: [orgId],
    sourceLocationId: [locId],
    type: ["APP"],
    sortByUpdatedDate: "DESCENDING",
  };

  const restaurantPayload = {
    page: 1,
    pageSize: 50,
    storeLocations: [locId],
    sortByUpdatedAt: "DESCENDING",
    storeIds: [orgId]
  };

  const fetchCategoryData = useFetch({
    name: "category-section",
    service: () =>
      retailType === "RESTAURANT" ? aggsFilterCategory(restaurantPayload) : filterCategory(payload),
    onSuccess: (e) => {
      setData(e?.data?.results);
      setCategoryLoader(false);
    },
  });
  useMemo(() => {
    if (!fetchCategoryData?.error) {
      return;
    }
    showSnackbar(fetchCategoryData?.error?.message, "error");
  }, [fetchCategoryData?.error]);

  const fetchingparticularCategoryDataFun = (categoryName) => {
    setCategoryLoader(true);
    const locId = localStorage.getItem("locId");
    let payload = {
      page: 1,
      pageSize: 100,
      appCategories: {
        categoryLevel1: [categoryName],
      },
      storeIds: [orgId],
      storeLocations: [locId],
      storeIds: [orgId],
      flattenResponse: true,
    };
    FilterProduct(payload)
      .then((res) => {
        setparticularCategoryItems(res?.data?.data?.data?.data);
        setCategoryLoader(false);
        setCategoryName(categoryName);
        navigate("/restaurant/cart");
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };
  //component-I
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Tab") {
        const focusableElements = firstRefElement?.current?.querySelectorAll(
          'a, button, input, select, textarea, [tabIndex]:not([tabIndex="-1"])'
        );
        const firstElement = focusableElements?.[0];
        const lastElement = focusableElements?.[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }

      if (e.key === "1" && e.altKey) {
        document.getElementById("myDiv").focus();
      }
      if (e.key === "2" && e.altKey) {
        document.getElementById("myDiv2").focus();
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <div id="myDiv" className="customerContainer" tabIndex="0" ref={firstRefElement}>
      {categoryLoader ? (
        <CircularProgress color="success" sx={{ color: "#5271ff" }} size={30} />
      ) : (
        data?.map((ele, index) => {
          return (
            <div key={index}>
              <PosCustomButton
                title={ele.categoryName}
                variant="blue-s"
                radius="4px"
                fontSize={"0.813rem"}
                transparent={true}
                p={"12px 12px 12px 12px"}
                onClickFunction={() => fetchingparticularCategoryDataFun(ele?.categoryName)}
              />
            </div>
          );
        })
      )}
    </div>
  );
};

export default TabmodalSecond;
